const ANZ_LOCALE = ['en_AU', 'en_NZ'];
export const isAboutSectionSearch = (section: string, locale: string) =>
  (section === 'about' || section === 'about-test') &&
  ANZ_LOCALE.includes(locale);
